/** Sport / Category and audience options — keep in sync with Coach Portal `curriculumConstants.js` */
export const SPORT_CATEGORY_OPTIONS = ['Flag Football', 'Soccer', 'Cheer', 'Basketball', 'General'];

/**
 * Standardized Grade Bands.
 * Each option has a stable value (stored in Firestore) plus display metadata
 * so that filters and badges stay consistent across Admin and Coach panels.
 */
export const GRADE_BANDS = [
  { value: 'Kindergarten - 1st Grade', label: 'Kindergarten - 1st Grade', level: 1, short: 'K – 1' },
  { value: '2nd - 3rd Grade', label: '2nd - 3rd Grade', level: 2, short: '2 – 3' },
  { value: '4th - 5th Grade', label: '4th - 5th Grade', level: 3, short: '4 – 5' },
  { value: 'Middle School (6th - 8th Grade)', label: 'Middle School', level: 4, short: '6 – 8' },
  { value: 'All Coaches', label: 'All Coaches', level: null, short: 'All' }
];

export const AUDIENCE_OPTIONS = GRADE_BANDS.map((band) => band.value);

export const getGradeBand = (value) =>
  GRADE_BANDS.find((band) => band.value === value) || null;

/** Weekday slots for weekly curriculum (Mon–Fri); Coach = coach-training block */
export const CURRICULUM_WEEKDAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
export const CURRICULUM_DAY_OPTIONS = [...CURRICULUM_WEEKDAYS, 'Coach'];

export const DAY_DISPLAY = {
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Coach: 'Coach training'
};
